import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacyPolicyPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1410">
      <Header data-id="element-1411" />
      <main className="flex-grow pt-36 pb-24" data-id="element-1412">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-1413">
          <div className="mb-8" data-id="element-1414">
            <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium" data-id="element-1415">
              <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-1416" />
              Back to Home
            </Link>
          </div>
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 sm:p-10" data-id="element-1417">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 font-serif" data-id="element-1418">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1419">
                Privacy Policy
              </span>
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-1420">Last Updated: August 13, 2025</p>
            <div className="prose prose-lg max-w-none text-gray-700" data-id="element-1421">
              <p data-id="element-1422">
                Creator Boost ("we," "our," or "us") is committed to protecting
                your privacy. This Privacy Policy explains how we collect, use,
                store, transfer, and protect your information when you use any
                of our services— including our tools (such as Newsfiliate and
                any future tools we develop), consulting services, directory
                services, and newsletters (collectively, the "Services").
              </p>
              <p data-id="element-1423">
                By accessing or using any of our Services, you agree to this
                Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1424">
                1. Information We Collect
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1425">
                <li data-id="element-1426">
                  <strong data-id="element-1427">Personal Information:</strong> Information you provide
                  when creating an account, joining our newsletter, purchasing
                  consulting services, or using our tools or directories—such as
                  your name, email address, contact details, and payment
                  information.
                </li>
                <li data-id="element-1428">
                  <strong data-id="element-1429">Account Data:</strong> Information from third-party
                  accounts or integrations you connect to our Services (e.g.,
                  Amazon, Kit.com, social media platforms).
                </li>
                <li data-id="element-1430">
                  <strong data-id="element-1431">Usage Data:</strong> Information about how you
                  interact with our Services (features accessed, time spent,
                  interactions, click data).
                </li>
                <li data-id="element-1432">
                  <strong data-id="element-1433">Device Information:</strong> Details about the device
                  and network you use (IP address, browser type, operating
                  system).
                </li>
                <li data-id="element-1434">
                  <strong data-id="element-1435">Directory Content:</strong> If you use our directory
                  services, we collect the information you submit for listing or
                  searching purposes.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1436">
                2. Legal Basis for Processing (GDPR)
              </h2>
              <p data-id="element-1437">
                If you are located in the European Economic Area (EEA), we
                process your personal data on one or more of these lawful bases:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1438">
                <li data-id="element-1439">
                  <strong data-id="element-1440">Consent:</strong> You have given clear consent for a
                  specific purpose.
                </li>
                <li data-id="element-1441">
                  <strong data-id="element-1442">Contractual Necessity:</strong> Processing is
                  necessary to perform our contract with you or take steps
                  before entering a contract.
                </li>
                <li data-id="element-1443">
                  <strong data-id="element-1444">Legitimate Interests:</strong> Processing is necessary
                  for our legitimate interests (e.g., improving our Services),
                  provided your rights do not override them.
                </li>
                <li data-id="element-1445">
                  <strong data-id="element-1446">Legal Obligations:</strong> Processing is necessary to
                  comply with a legal obligation.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1447">
                We do not specifically target or market our Services to EU/EEA
                residents. However, if you are in the EU/EEA and use our
                Services, you retain all rights granted under the GDPR.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1448">
                3. International Data Transfers
              </h2>
              <p data-id="element-1449">
                Your data may be transferred to and stored on servers outside
                your country of residence, including in the United States. Where
                data is transferred from the EEA to countries without an
                adequacy decision, we use safeguards such as Standard
                Contractual Clauses approved by the European Commission.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1450">
                4. Cookies and Tracking Technologies
              </h2>
              <p data-id="element-1451">We use cookies and similar technologies to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1452">
                <li data-id="element-1453">Provide and improve our Services</li>
                <li data-id="element-1454">Analyze usage trends</li>
                <li data-id="element-1455">Personalize content and marketing</li>
              </ul>
              <p className="mt-4" data-id="element-1456">
                If you reside in the EU, we will obtain your consent before
                placing non-essential cookies. You can manage your cookie
                preferences via our cookie banner and browser settings.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1457">
                5. Third-Party Services & Integrations
              </h2>
              <p data-id="element-1458">
                Some of our Services integrate with third-party platforms (e.g.,
                Kit.com, Amazon, payment processors). Their privacy policies
                will apply in addition to ours. We encourage you to review them,
                as we do not control their practices.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1459">
                6. Data Security & Retention
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1460">
                <li data-id="element-1461">
                  <strong data-id="element-1462">Security:</strong> We use industry-standard security
                  measures (encryption, access controls) to protect your data.
                </li>
                <li data-id="element-1463">
                  <strong data-id="element-1464">Retention:</strong> We keep your personal data as long
                  as necessary to:
                  <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-1465">
                    <li data-id="element-1466">Deliver Services</li>
                    <li data-id="element-1467">Comply with legal obligations</li>
                    <li data-id="element-1468">Resolve disputes</li>
                    <li data-id="element-1469">Enforce agreements</li>
                  </ul>
                </li>
              </ul>
              <p className="mt-4" data-id="element-1470">
                You may request deletion of your data by contacting us at
                gavin.smith@creatorboost.ai.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1471">
                7. Your Privacy Rights
              </h2>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1472">
                7.1 Global Rights
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1473">
                <li data-id="element-1474">
                  <strong data-id="element-1475">Access:</strong> Request a copy of your personal data.
                </li>
                <li data-id="element-1476">
                  <strong data-id="element-1477">Correction:</strong> Request corrections to inaccurate
                  or incomplete data.
                </li>
                <li data-id="element-1478">
                  <strong data-id="element-1479">Deletion:</strong> Request deletion, subject to legal
                  exceptions.
                </li>
                <li data-id="element-1480">
                  <strong data-id="element-1481">Restriction:</strong> Request limited processing under
                  certain conditions.
                </li>
                <li data-id="element-1482">
                  <strong data-id="element-1483">Data Portability:</strong> Receive your data in a
                  portable format.
                </li>
                <li data-id="element-1484">
                  <strong data-id="element-1485">Withdraw Consent:</strong> Where applicable, withdraw
                  consent at any time.
                </li>
              </ul>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1486">
                7.2 EU/EEA Rights (GDPR)
              </h3>
              <p data-id="element-1487">If you reside in the EEA, you may also:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1488">
                <li data-id="element-1489">
                  Lodge a complaint with your local data protection authority.
                </li>
                <li data-id="element-1490">
                  Request details of safeguards applied when your data is
                  transferred outside the EEA.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1491">
                We have not appointed an EU Representative, as we do not
                specifically target EU/EEA residents, but we comply with GDPR
                requirements for EU/EEA users.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1492">
                7.3 California Privacy Rights (CCPA/CPRA)
              </h3>
              <p data-id="element-1493">If you are a California resident, you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1494">
                <li data-id="element-1495">
                  Know the categories of personal information we collect,
                  sources, purposes, and third parties with whom we share it.
                </li>
                <li data-id="element-1496">
                  Opt out of the "sale" or "sharing" of your personal
                  information (as defined by California law).
                </li>
                <li data-id="element-1497">
                  Request deletion of your personal information, subject to
                  certain exceptions.
                </li>
                <li data-id="element-1498">
                  Not be discriminated against for exercising your rights.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1499">
                To exercise these rights, contact gavin.smith@creatorboost.ai or
                use our "Do Not Sell or Share My Info" page (if applicable).
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1500">
                8. Children's Privacy
              </h2>
              <p data-id="element-1501">
                Our Services are not intended for individuals under 18. We do
                not knowingly collect data from children. If we learn that a
                minor has provided us with personal data, we will delete it
                promptly.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1502">
                9. Changes to This Privacy Policy
              </h2>
              <p data-id="element-1503">
                We may update this Privacy Policy from time to time. Significant
                changes will be communicated via email or through our Services.
                Continued use after the effective date means you accept the
                updated policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1504">
                10. Contact Us
              </h2>
              <p className="mt-2" data-id="element-1505">
                <strong data-id="element-1506">Email:</strong> gavin.smith@creatorboost.ai
              </p>
              <p data-id="element-1507">
                <strong data-id="element-1508">Address:</strong> 3500 S Dupont Highway, Dover, Delaware
                19901
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1509" />
    </div>;
}